import SuccessIconGreenFill from "../../Icons/SucessIconGreenFill";
import WarningIcon from "../../Icons/WarningIcon";

const StatusIcon = ({ isOpen, completed }) => {
    if (!isOpen && !completed) {
        return (
            <WarningIcon />


        );
    }

    if (isOpen && !completed) {

        return (



            <span className="inline-flex items-center justify-center w-6 h-6 text-blue-500 text-sm">
                ⏳
            </span>

        );
    }

    if (completed) {
        return (
            <SuccessIconGreenFill />
        );
    }

    return null;
};

export default StatusIcon;
